// extracted by mini-css-extract-plugin
export var container = "_6x-0";
export var error = "_6x-9";
export var label = "_6x-5";
export var light = "_6x-6";
export var md = "_6x-3";
export var sm = "_6x-2";
export var thin = "_6x-8";
export var thinBold = "_6x-7";
export var vertical = "_6x-4";
export var xs = "_6x-1";